export default __webpack_public_path__ + "f59c202f9cc7a67543765c1722c125c4.svg";